import { StyleRules } from '@material-ui/core/styles';
import { OutlinedInputClassKey } from '@material-ui/core/OutlinedInput';

import { core as theme } from '../styles/core';

export const MuiOutlinedInput: Partial<StyleRules<OutlinedInputClassKey>> = {
  root: {
    '&$disabled input': {
      cursor: 'not-allowed',
    },
    '&$disabled $notchedOutline': {
      borderColor: theme.palette.grey[200],
    },
    '&$disabled:hover $notchedOutline': {
      borderColor: theme.palette.grey[200],
    },
    'label + &': {
      marginTop: theme.spacing(1),
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.grey[500],
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderWidth: 1,
      borderColor: (props: { color: string }) =>
        props.color &&
        (props.color === 'primary' || props.color === 'secondary')
          ? theme.palette[props.color].main
          : theme.palette.primary.main,
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.error.main,
    },
    '&.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.error.main,
    },
    '&.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.error.main,
    },
    ...theme.typography.body2,
  },
  input: {
    padding: `${theme.spacing(1.5)}px ${theme.spacing(1)}px`,
  },
  notchedOutline: {
    borderColor: theme.palette.grey.A700,
  },
  adornedStart: {
    paddingLeft: theme.spacing(1),
  },
  adornedEnd: {
    paddingRight: theme.spacing(1),
  },
};
